export default "__VITE_ASSET__DV5HfX0y__"